import { BitfStrapiModel } from '@common/libs/bitforce/core/models/strapi/bitf-strapi.model';

export class Image extends BitfStrapiModel {
  name?: string;
  alternativeText?: string;
  caption?: string;
  createdAt?: Date;
  ext?: string;
  hash?: string;
  height?: number;
  mim?: string;
  previewUrl?: string;
  provider?: string;
  provider_metadata?: {
    public_id?: string;
    resource_type?: string;
  };
  size?: string;
  updatedAt?: Date;
  url?: string;
  width?: number;
  // formats?: {
  //   // Default format used from strapi UI
  //   thumbnail?: ImageFormat;
  //   small?: ImageFormat;
  // };

  get isLandscape(): boolean {
    if (this.width > this.height) {
      return true;
    }
    return false;
  }
  get isPortrait(): boolean {
    if (this.height > this.width) {
      return true;
    }
    return false;
  }
  get isSquare(): boolean {
    if (this.height === this.width) {
      return true;
    }
    return false;
  }

  constructor(data?: any) {
    super({
      data,
      hydrateProperties: {},
      serializeProperties: [],
    });
  }

  get serialised() {
    return {};
  }
}

// export class ImageFormat {
//   ext: string;
//   hash: string;
//   height: number;
//   mime: string;
//   name: string;
//   path: string;
//   size: number;
//   url: string;
//   width: number;
//   provider_metadata: {
//     public_id: string;
//     resource_type: string;
//   };

//   get isLandscape(): boolean {
//     // NOTE: thumbnail is always present
//     if (this.width > this.height) {
//       return true;
//     }
//     return false;
//   }
//   get isPortrait(): boolean {
//     if (this.height > this.width) {
//       return true;
//     }
//     return false;
//   }
//   get isSquare(): boolean {
//     if (this.height === this.width) {
//       return true;
//     }
//     return false;
//   }

//   constructor(data) {
//     Object.assign(this, data);
//   }
// }
